import React from 'react';
import type { TrackHoursTermScope } from '../../utils/trackHoursTermScopeStorage';

type TrackHoursTermScopeToggleProps = {
  value: TrackHoursTermScope;
  onChange?: (next: TrackHoursTermScope) => void;
};

const TrackHoursTermScopeToggle: React.FC<TrackHoursTermScopeToggleProps> = ({
  value,
  onChange,
}) => {
  const isUnified = value === 'unified';
  return (
    <div
      className="track-col-criteria track-col-term-scope"
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className={
          'track-col-term-scope-toggle' + (isUnified ? ' is-unified' : ' is-split')
        }
        title="클릭하면 1·2학기 구분/통합이 바뀝니다"
        aria-pressed={isUnified}
        aria-label={isUnified ? '1·2학기 통합' : '1·2학기 구분'}
        onClick={() => onChange?.(isUnified ? 'split' : 'unified')}
      >
        {isUnified ? '1·2학기 통합' : '1·2학기 구분'}
      </button>
    </div>
  );
};

export default TrackHoursTermScopeToggle;
